import React from "react";

function MenuCountriesListCard({ text }: any) {
  return <div className="menu__list__card">{text}</div>;
}

export default MenuCountriesListCard;
